const API_URL = 'https://api-develop-menuvia.haniftech.net/api';

export const environment = {
  production: false,
  apiUrl: API_URL,
  realtimeUrl: API_URL.replace(/\/api\/?$/, ''),
  useMocks: false,
};
